export default {"src":"/_next/static/media/TjHeader.95ffc6b1.svg","height":40,"width":733,"blurWidth":0,"blurHeight":0};